import r from "./_trimmedEndIndex.js";
var a = r, m = /^\s+/;
function d(e) {
  return e && e.slice(0, a(e) + 1).replace(m, "");
}
var i = d;
export {
  i as default
};
//# sourceMappingURL=_baseTrim.js.map
